import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_notification-list.scss'

const NotificationCenter = () => {
    return (
        <div className='notification'>

            <PageTitle
                title="Notification Center"
                subtitle="Here are the messages you received"
            />

            <div className='mt-5 d-flex justify-content-between'>
                <span>Uread</span>
                <span>
                    Mark all as read
                </span>
            </div>

            <div className="card rounded-0 mt-2">
                <div className="card-body w-100">
                    <div className="row w-100 d-flex justify-content-between align-items-center">
                        <div className="col-md-8 col-lg-8 notification-body">
                            <ul>
                                <li>
                                    <b>First device check in then working</b>
                                    <br />
                                    <span className='ms-3'> Lorem sum lorem sum lorem sum   Lorem sum lorem sum lorem sum  Lorem sum lorem sum lorem sum</span>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-2 col-lg-2 text-right">
                               <span>2 days ago</span>
                        </div>
                    </div>
                     <hr/>
                    <div className="row w-100 d-flex justify-content-between align-items-center">
                        <div className="col-md-8 col-lg-8 notification-body">
                            <ul>
                                <li>
                                    <b>First device check in then working</b>
                                    <br />
                                    <span className='ms-3'> Lorem sum lorem sum lorem sum   Lorem sum lorem sum lorem sum  Lorem sum lorem sum lorem sum</span>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-2 col-lg-2 text-right">
                            <span>10 days ago</span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default NotificationCenter;